export default function dropdownPanel({main, on, elm}) {
    const dropdownBox = elm.querySelector('[dropdown-box]');

    main(() => {
        on('click', '[dropdown-btn]', toggle);
        document.addEventListener('click', close);
    });

    const toggle = function () {
        dropdownBox.classList.toggle('dropdown__box--open');
    };

    const close = function (e) {
        if (!e.target.closest('dropdown-panel'))
            dropdownBox.classList.remove('dropdown__box--open');
    }
};

export const model = {};
